(function () {
    var $container = $(document.getElementById('fias'));

    var $address = $container.find('.fias__field');
    var $region = $container.find('.fias__field--region');

    $address.fias({
        oneString: true,
        change: function (obj) {
            $region.val(obj.parents[0].name)
        }
    });
})();
